import ModusServiceModel from "../ModusServiceModel";
import ResultEventModel from "./ResultEventModel";
import ResultEventSampleModel from "./ResultEventSampleModel";
import ResultNutrientElementCollection from "@/collections/modus/ResultNutrientElementCollection";

export default class ResultNutrientModel extends ModusServiceModel {
  modelName() {
    return 'result-nutrients';
  }
  icon() {
    return 'atom';
  }
  defaults() {
    return {
      id: null,
      result_event_id: null,
      result_event: null,
      result_event_sample_id: null,
      result_event_sample: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      result_nutrient_elements: {}
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      result_event_id: (val) => (this.nullStringMutator(val)),
      result_event_sample_id: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }
  validation() {
    return {}
  }
  getResultEvent() {
    return this.getRelatedModel(ResultEventModel, 'result_event');
  }
  getResultEventSample() {
    return this.getRelatedModel(ResultEventSampleModel, 'result_event_sample');
  }
  getResultNutrientElements() {
    return this.getRelatedCollection(new ResultNutrientElementCollection(), 'result_nutrient_elements');
  }
}
